import { getDefaultValueForType } from "./derivedLists";
import { resolveTypeKey, semanticToVisibleType } from "./resolve";
import {
  coerceDateOnly,
  coerceDateTimeLocal,
  coerceString,
  coerceTimeOnly,
  sanitizeCurrencyForApi,
} from "./parsers";
import { unwrapEnumLikeValue } from "./normalizeInbound";

/**
 * Serialize editor field shape to API payload.
 */
export const serializeCustomField = (field) => {
  if (!field) return null;
  const typeKey = resolveTypeKey(field.type || field.visibleType);

  const base = {
    name: (field.name || "").trim(),
    type: typeKey,
  };

  if (!base.name) return null;

  switch (typeKey) {
    case "PERIOD":
      return {
        ...base,
        startDate: coerceDateOnly(field.startDate),
        endDate: coerceDateOnly(field.endDate),
      };
    case "DATE":
      return { ...base, value: coerceDateOnly(field.value) };
    case "TIME": {
      const time = coerceTimeOnly(field.value);
      return {
        ...base,
        value: time || (typeof field.value === "string" ? field.value.slice(0, 5) : null),
      };
    }
    case "DATETIME":
      return { ...base, value: coerceDateTimeLocal(field.value) };
    case "URL":
      return { ...base, value: coerceString(field.value).trim() };
    case "CURRENCY":
      return { ...base, value: sanitizeCurrencyForApi(field.value) };
    case "STRING_ARRAY":
      return {
        ...base,
        value: Array.isArray(field.value)
          ? field.value.map((item) => coerceString(item).trim()).filter(Boolean)
          : [],
      };
    case "ENUM":
    case "COMBOLIST": {
      const unwrapped = unwrapEnumLikeValue(field.value, field.options);
      return {
        ...base,
        options: unwrapped.options,
        value: unwrapped.value,
      };
    }
    default:
      return {
        ...base,
        value:
          field.value !== undefined && field.value !== null
            ? field.value
            : getDefaultValueForType(typeKey),
      };
  }
};

export const serializeFieldsForBackend = (fields = []) =>
  fields.map(serializeCustomField).filter((field) => field && field.name);

export const getImportFieldTypeLabel = (fieldType) =>
  semanticToVisibleType(resolveTypeKey(fieldType || "STRING"));
